import PersonLabel from "./PersonLabel";
export default PersonLabel;